import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { getJobChatSummary } from "../actions/jobChats.actions";
import { jobChatsQueryKeys } from "../jobChats.queryKeys";

export const jobChatSummaryQueryKey = (companyId: string | number | null | undefined, jobEventUid: string | undefined) =>
  jobChatsQueryKeys.summary(companyId, jobEventUid);

export const useJobChatSummaryQuery = ({ jobEventUid, companyId, enabled = true } = {}) => {
  const token = sessionStorage.getItem("token");
  const activeCompanyId = useSelector((state: any) => state.userState.activeCompanyId);
  const effectiveCompanyId = companyId ?? activeCompanyId;

  return useQuery({
    queryKey: jobChatSummaryQueryKey(effectiveCompanyId, jobEventUid),
    queryFn: () => getJobChatSummary(token, jobEventUid, effectiveCompanyId),
    enabled: Boolean(token && effectiveCompanyId && jobEventUid) && enabled,
    refetchOnWindowFocus: false,
    staleTime: 30000,
  });
};
